import actionTypes from './index';
import { getItemIdsForEstimate } from '../../selectors/getItemsForEstimate';

const expandAll = () => (dispatch, getState) => {
  const { entities, uiState } = getState().estimateBuilder;
  const items = getItemIdsForEstimate(entities, uiState.selectedEstimate);
  dispatch({ type: actionTypes.EXPAND_ALL, payload: { items } });
};

export default expandAll;
